var _ellipse, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.95824,
    cy: 5.95825,
    rx: 5.95824,
    ry: 5.95825,
    fill: "url(#paint0_linear_299_17432)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55357 3.25333C7.2484 2.9065 7.08023 2.46108 7.08036 2H5.70089V7.51111C5.69025 7.80934 5.56378 8.09183 5.34811 8.29908C5.13244 8.50634 4.8444 8.62218 4.54464 8.62222C3.91071 8.62222 3.38393 8.10667 3.38393 7.46667C3.38393 6.70222 4.125 6.12889 4.88839 6.36444V4.96C3.34821 4.75556 2 5.94667 2 7.46667C2 8.94667 3.23214 10 4.54018 10C5.94196 10 7.08036 8.86667 7.08036 7.46667V4.67111C7.63973 5.07104 8.31132 5.28562 9 5.28444V3.91111C9 3.91111 8.16071 3.95111 7.55357 3.25333Z",
    fill: "#565656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_17432",
    x1: 5.95824,
    y1: -2.14497,
    x2: 5.95824,
    y2: 13.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg8);
export default __webpack_public_path__ + "static/media/img8.a02ca5662cd91926e661d4d9412bb0d7.svg";
export { ForwardRef as ReactComponent };